// extracted by mini-css-extract-plugin
export default {"gameContainer":"Game_gameContainer__gViSw","fieldContainer":"Game_fieldContainer__UvMOm"};